import React, { Suspense } from 'react';

/**
 * Demo routing (brief §7.1, §7.5).
 *
 *   /demos/visual-maths          the hub
 *   /demos/<mode>                that mode's first scene
 *   /demos/<mode>/<scene-id>     a particular scene, which is the link a
 *                                researcher can send and reproduce
 *
 * Lazily loaded: nine modes must not sit in the bundle the daily waits for.
 */

const Hub = React.lazy(() =>
  import('./DemoHub').then((m) => ({ default: m.DemoHub }))
);
const Reflection = React.lazy(() =>
  import('./reflection/ReflectionDemo').then((m) => ({ default: m.ReflectionDemo }))
);
const Slice = React.lazy(() =>
  import('./slice/SliceDemo').then((m) => ({ default: m.SliceDemo }))
);
const Balance = React.lazy(() =>
  import('./balance/BalanceDemo').then((m) => ({ default: m.BalanceDemo }))
);
const LetGo = React.lazy(() =>
  import('./letgo/LetGoDemo').then((m) => ({ default: m.LetGoDemo }))
);
const Route = React.lazy(() =>
  import('./route/RouteDemo').then((m) => ({ default: m.RouteDemo }))
);

const Scale = React.lazy(() =>
  import('./scale/ScaleDemo').then((m) => ({ default: m.ScaleDemo }))
);
const Unspool = React.lazy(() =>
  import('./unspool/UnspoolDemo').then((m) => ({ default: m.UnspoolDemo }))
);
const Shadow = React.lazy(() =>
  import('./shadow/ShadowDemo').then((m) => ({ default: m.ShadowDemo }))
);
const Drift = React.lazy(() =>
  import('./drift/DriftDemo').then((m) => ({ default: m.DriftDemo }))
);

const Review = React.lazy(() =>
  import('./ReviewSheet').then((m) => ({ default: m.ReviewSheet }))
);

const MODE_PAGES = {
  reflection: Reflection,
  slice: Slice,
  balance: Balance,
  'let-go': LetGo,
  'fastest-route': Route,
  scale: Scale,
  unspool: Unspool,
  shadow: Shadow,
  drift: Drift,
};

export function demoPage(path) {
  if (!path.startsWith('/demos')) return null;

  const [, , mode, sceneId] = path.split('/');
  const render = (node) => <Suspense fallback={null}>{node}</Suspense>;

  if (!mode || mode === 'visual-maths') return render(<Hub />);
  // A team surface for judging a run, not a player one.
  if (mode === 'review') return render(<Review mode={sceneId ?? 'slice'} />);

  const Page = MODE_PAGES[mode];
  if (!Page) return render(<Hub />);
  return render(<Page sceneId={sceneId} />);
}
